import React from 'react';
import { Outlet, createRoute, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { OrderLayout } from 'components/layout';
import { store } from 'store/store';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectUserAuthenticated, logout } from 'store/user';
import { heartbeat, init, selectInitialized } from 'store/messenger';
import { selectOrderHasEnded } from 'store/order';
import { useIdleTimer } from 'react-idle-timer';

export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authenticated',
  beforeLoad: async ({ location }) => {
    const state = store.getState();
    const isAuthenticated = selectUserAuthenticated(state);

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      });
    }

    const orderHasEnded = selectOrderHasEnded(state);
    if (orderHasEnded && location.pathname !== '/order-summary') {
      throw redirect({
        to: '/order-summary',
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const dispatch = useAppDispatch();
  const initialized = useAppSelector(selectInitialized);

  React.useEffect(() => {
    if (!initialized) {
      dispatch(init());
    }
  }, [initialized]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      dispatch(heartbeat());
    }, 30000);
    return () => clearInterval(timer);
  }, []);

  const handleOnIdle = () => {
    if (globalThis.twilioRoom != undefined) {
      window.dispatchEvent(new Event('disconnectFromRoom'));
    }
    setTimeout(() => {
      dispatch(logout());
    }, 1000);
  };

  //3600000 = 1 hour
  //43200000 = 12 hours
  useIdleTimer({
    timeout: 43200000,
    onIdle: handleOnIdle,
    debounce: 500
  });

  return (
    <OrderLayout>
      <Outlet />
    </OrderLayout>
  );
}
